import Vue from 'vue';
import Vuex, {MutationTree, ActionTree, GetterTree} from 'vuex';

import {TasksState} from '../models/store-viewmodel';
import {Config, SourceSystem} from '../models/config-viewmodel';
import {TaskSourceSystem, Task} from '../models/task-viewmodels';

import {root} from '@/shared/store/index';

Vue.use(Vuex);

const state: TasksState = {
    taskSourceSystems: [],
    errors: [],
    loading: true,
    config: {
        language: '',
        labels: {},
        userId: '',
        apiBasePath: '',
        sourceSystem: SourceSystem.SAP
    },
    sourceSystemsFilter: {
        name: 'asc',
        order: 'asc',
        status: 'asc'
    }
}

const mutations: MutationTree<TasksState> = {
    setConfig(state, config: Config) {
        state.config = config;
    },

    setLoading(state, loading: boolean) {
        state.loading = loading;
    },

    setError(state, error: string) {
        state.errors.push(error);
    },

    setErrors(state, errors: string[]) {
        state.errors = errors;
    },

    setTaskSourceSystems(state, taskSourceSystems: TaskSourceSystem[]) {
        state.taskSourceSystems = taskSourceSystems;
    },
    setSourceSystemNameSorting(state, sortingOrder: string) {
        state.sourceSystemsFilter.name = sortingOrder;
    }
}

const actions: ActionTree<TasksState, TasksState> = {
    setTaskSourceSystems(context, taskSourceSystems: TaskSourceSystem[]) {
        context.commit('setTaskSourceSystems', taskSourceSystems);
    },
    setSourceSystemNameSorting(context, sortingOrder: string) {
        context.commit('setSourceSystemNameSorting', sortingOrder);
    },
    setConfig(context, config: Config) {
        context.commit('setConfig', config);
    },

    setLoading(context, loading: boolean) {
        context.commit('setLoading', loading);
    },
    setError(context, error: string) {
        context.commit('setError', error);
    },
    setErrors(context, errors: string[]) {
        context.commit('setErrors', errors);
    }
}

const getters: GetterTree<TasksState, TasksState> = {
    config(state) {
        return state.config;
    },

    loading(state) {
        return state.loading;
    },

    errors(state) {
        return state.errors;
    },

    sourceSystemsErrors(state) {
        return state.taskSourceSystems.reduce((errorArr: TaskSourceSystem[], system: TaskSourceSystem) => {
            if (system.validResponse === false) {
                errorArr.push(system);
            }

            return errorArr;
        }, [])
    },

    getTaskSourceSystems(state) {
        return state.taskSourceSystems;
    },

    tasks(state) {
        return state.taskSourceSystems.reduce((taskArr: Task[], system: TaskSourceSystem) => {
            return [...taskArr, ...system.tasks];
        }, [])
    },

    noResultsFound(state, getters) {
        return getters.tasks
            && getters.tasks.length === 0
            && !getters.loading
            && getters.errors.length === 0
            && getters.sourceSystemsErrors.length === 0
    },
    getSortedSourceSystems(state) {
        if (state.sourceSystemsFilter.name === 'asc') {
            return state.taskSourceSystems.sort((a: TaskSourceSystem, b: TaskSourceSystem) => (a.sourceSystem > b.sourceSystem) ? 1 : ((b.sourceSystem > a.sourceSystem) ? -1 : 0))
        }
        return state.taskSourceSystems.sort((a: TaskSourceSystem, b: TaskSourceSystem) => (a.sourceSystem < b.sourceSystem) ? 1 : ((b.sourceSystem < a.sourceSystem) ? -1 : 0))
    }
}

export default new Vuex.Store({
    state,
    mutations,
    actions,
    getters,
    modules: {
        root
    }
})
